import { makeGetRequest } from "./apiRequest";
import { PROGRESS_PICTURES_URL } from "./conf";



export async function listProgressPictures(params) {
  return await makeGetRequest(PROGRESS_PICTURES_URL, params);
}
